import React, { useState, useContext, useEffect } from 'react';
import { Button, TextField, Autocomplete } from '@mui/material';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { PassportAuth } from '../../contexts/AuthContext';
import { getStorage } from '../../utils/functions/localstorage';
import { useGetMerchantUserRoleQuery } from '../../services/merchant';
import { setSelectedMerchant } from '../../features/merchant/merchantSlice';
import { setSelectedCustomerNO } from '../../features/merchant/custNOSlice';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LanguageIcon from '@mui/icons-material/Language';

export default function Navbar({
  handleSidebarToggle,
  handleMobileNavbarToggle,
  isMobileNavbarOpen,
}) {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const toggleLanguage = () => {
    const newLang = lang === 'th' ? 'en' : 'th';
    i18n.changeLanguage(newLang);
  };

  const { handleSignout } = useContext(PassportAuth);
  const userName = getStorage('name');
  const [value, setValue] = useState([]);
  const [merchantName, setMerchantName] = useState('');
  const [filteredCustomerCodes, setFilteredCustomerCodes] = useState([]);
  const [customerCode, setCustomerCode] = useState('');
  const [merchants, setMerchants] = useState([]);
  const [CustNo, setCustNo] = useState([]);
  const { data, error, isLoading } = useGetMerchantUserRoleQuery();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const supportsAllCustomers = pathname === '/' || pathname === '/invoice-main';

  const getCustomerCodeOptions = (customerCodes = []) =>
    supportsAllCustomers && customerCodes.length > 1
      ? ['All', ...customerCodes]
      : customerCodes;
  // console.log('data : ', data);

  useEffect(() => {
    if (data?.message === 'success') {
      setValue(data?.data);
    } else {
      setValue([]);
    }
  }, [data]);

  useEffect(() => {
    if (value.length !== 0) {
      setMerchantName(value[0].merchant_name);
      // setMerchantValue(value[0].sorgcode);
      dispatch(setSelectedMerchant(value[0].sorgcode));
    } else {
      setMerchantName('');
    }
  }, [value]);

  const handleMerchantNameChange = (_, newValue) => {
    setMerchantName(newValue);
    const selectedData = value.find(
      // eslint-disable-next-line camelcase
      ({ merchant_name }) => merchant_name === newValue,
    );
    // console.log('selectedData', selectedData);
    const customerCodeOptions = getCustomerCodeOptions(
      selectedData?.customer_code || [],
    );
    setFilteredCustomerCodes(customerCodeOptions);
    setCustomerCode(customerCodeOptions[0] || '');
    dispatch(setSelectedMerchant(selectedData.sorgcode || ''));
  };
  useEffect(() => {
    const initialCustomerCodes =
      // eslint-disable-next-line camelcase
      value.find(({ merchant_name }) => merchant_name === merchantName)
        ?.customer_code || [];

    const customerCodeOptions = getCustomerCodeOptions(initialCustomerCodes);
    dispatch(setSelectedCustomerNO(customerCodeOptions[0] || ''));
    setFilteredCustomerCodes(customerCodeOptions);
    setCustomerCode(customerCodeOptions[0] || '');
  }, [merchantName, supportsAllCustomers]);

  const responsiveWidth = {
    width: {
      xs: '100%', //
      lg: 250, //
    },
    minWidth: 250, // คง minWidth ไว้
    background: '#ffff',
  };

  return (
    <nav
      className={`
        bg-[#f5f5f5]
        border-b border-[#ddd]
        shadow-md
        transition-all duration-300 ease-in-out
      `}
    >
      <div className="flex flex-col md:flex-row gap-5 p-2 md:items-center">
        <div className="flex justify-end">
          <div
            className="md:hidden flex justify-end cursor-pointer"
            onClick={handleSidebarToggle}
          >
            <MenuIcon />
          </div>

          <div
            className="cursor-pointer ml-2 md:hidden"
            onClick={handleMobileNavbarToggle}
          >
            {isMobileNavbarOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
        </div>

        <div
          className={`
          ${isMobileNavbarOpen ? 'flex flex-col' : 'hidden'}  
          md:flex md:flex-row md:flex-wrap md:flex-1 gap-5 p-2 
        `}
        >
          <div className="">
            <Autocomplete
              id="merchant_name"
              disablePortal
              disableClearable
              sx={responsiveWidth} // ใช้ sx ที่กำหนด
              size="small"
              // eslint-disable-next-line camelcase
              options={value.map(({ merchant_name }) => merchant_name)}
              renderInput={(params) => (
                <TextField
                  sx={{
                    background: '#ffff',
                  }}
                  {...params}
                  label={t('navbar.venderCompany')}
                  variant="outlined"
                />
              )}
              value={merchantName}
              onChange={handleMerchantNameChange}
              // inputValue={merchantName}
              // onInputChange={(_, newInputValue) => setMerchantName(newInputValue)}
            />
          </div>
          <div>
            <Autocomplete
              id="customer_code"
              disablePortal
              disableClearable
              sx={responsiveWidth} // ใช้ sx ที่กำหนด
              size="small"
              options={filteredCustomerCodes}
              renderInput={(params) => (
                <TextField
                  sx={{
                    background: '#ffff',
                  }}
                  {...params}
                  label={t('navbar.custNo')}
                  variant="outlined"
                />
              )}
              value={customerCode}
              onChange={(_, newValue) => {
                dispatch(setSelectedCustomerNO(newValue || ''));
                setCustomerCode(newValue);
              }}
              inputValue={customerCode}
              onInputChange={(_, newInputValue) =>
                setCustomerCode(newInputValue)
              }
              disabled={!merchantName}
            />
          </div>
          <div>
            <TextField
              size="small"
              variant="outlined"
              label={t('navbar.custName')}
              defaultValue={userName}
              sx={responsiveWidth}
              InputProps={{
                readOnly: true,
              }}
            />
          </div>
        </div>
        <div className="hidden md:flex ml-auto items-center gap-4">
          <span className="text-gray-500 text-sm font-medium select-none">
            {t('app.welcome')}
          </span>

          <div className="flex items-center gap-2">
            <Button
              onClick={toggleLanguage}
              color="primary"
              size="small"
              style={{ minWidth: 'auto', padding: '6px 12px' }}
            >
              <LanguageIcon fontSize="small" style={{ marginRight: 6 }} />
              <span className="font-medium pt-0.5">
                {lang === 'th' ? 'TH' : 'EN'}
              </span>
            </Button>

            <div className="h-5 w-[1px] bg-gray-300 mx-1"></div>

            <Button
              color="error"
              size="small"
              onClick={handleSignout}
              style={{ minWidth: '40px' }}
            >
              <LogoutIcon fontSize="small" />
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
}
